import React, { useState, useEffect } from "react";
//import "./styles.css";
// import {  Row, Col } from 'react-bootstrap';
import LeftpanelMember from "../../components/leftpanel/leftpanel-member";
import HeaderPart from "../../components/layout/header/header";
import Moment from "react-moment";
import axios from "../../axios/axios";
// import BodyTextEditor from "./BodyTextEditor";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import { FaMoneyBillWave } from "react-icons/fa";
import DataTable from "react-data-table-component";
import moment from "moment";
import { DATE_AND_TIME_FORMAT } from "../../constants/constant";

const UserEscapeBucks = () => {
    const [loading, setLoading] = useState(true);
    const [allCals, setAllCals] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [total, setTotal] = useState(0);
    const [limit, setLimit] = useState(10);

    const columns = [
        {
            name: "Code",
            selector: (row) => row.code,
            sortable: true,
        },
        {
            name: "Amount",
            selector: (row) => `$${row.amount}`,
            sortable: true,
        },
        {
            name: "Date",
            selector: (row) => moment(row.createdAt).format(DATE_AND_TIME_FORMAT),
            sortable: true,
        }
    ];

    const StatCard = ({ bg, icon, count, label }) => (
        <Card
            className="text-white border-0 h-100"
            style={{
                backgroundColor: bg,
                borderRadius: "8px"
            }}
        >
            <Card.Body className="d-flex align-items-center justify-content-between px-4">
                <div style={{ fontSize: "42px", opacity: 0.9 }}>
                    {icon}
                </div>

                <div className="text-end">
                    <h2 className="fw-bold mb-0">${count}</h2>
                    <small>{label}</small>
                </div>
            </Card.Body>
        </Card>
    );

    const fetchCals = async (page, limit) => {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("AuthToken")}`,
            },
        };
        await axios
            .get(`/user/get-vip-user-code-redeem-list?page=${page}&limit=${limit}`, config)
            .then((res) => {
                if (res.data.status) {
                    setAllCals(res.data.data);
                    setTotalAmount(res.data.totalAmount)
                    setTotal(res.data.pagination?.totalRows);
                    setLoading(false);
                } else {
                    setAllCals([]);
                    message.error(res.data.message);
                }
            })
            .catch((err) => {
                console.log("err", err);
            });
    };

    useEffect(() => {
        fetchCals();
    }, []);

    const [careFiCode, setCareFiCode] = useState("");
    const handelChange = (e) => {
        setCareFiCode(e.target.value);

    }

    const submitCode = async () => {
        if (!careFiCode) {
            message.error("Please enter code");
            return;
        }
         setLoading(true);
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("AuthToken")}`,
            },
        };
        await axios
            .post(`/user/redeem-vip-code`, { code: careFiCode }, config)
            .then((res) => {
                if (res.data.status) {
                    message.success(res.data.message);
                    setCareFiCode("");
                    fetchCals();
                    setLoading(false);
                } else {
                     setLoading(false);
                    message.error(res.data.message);
                }
            })
            .catch((err) => {
                 setLoading(false);
                console.log("err", err);
                message.error("Something went wrong. Please try again");
            });
    }

    return (
        <LoadingOverlay active={loading} spinner text="Loading ...">
            <HeaderPart />
            <div className="main_cont">
                <LeftpanelMember />
                <div className="right_cont">
                    <div className="right_banner_banner_cnt">
                        <div className="event_heading">
                            <h2>Escape Bucks</h2>
                        </div>
                        <Row className="g-3">
                            <Col md={3}>
                                <StatCard
                                    bg="#004aad"
                                    icon={<FaMoneyBillWave />}
                                    count={totalAmount}
                                    label="Total Escape Bucks"
                                />
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <h4>Redeem your CareFi Code</h4>
                            <Col md={12}>
                                <Form className="mt-3">
                                    <Row>
                                        <Col lg="6" md="6" sm="12">
                                            <Form.Group className="" controlId="formBasicEmail">

                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter CareFi Code"
                                                    name="first"
                                                    className="modal_t_field"
                                                    value={careFiCode}
                                                    onChange={handelChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col lg="6" md="6" sm="12">
                                            <Form.Group className="mt-1" controlId="formBasicEmail">
                                                <Button
                                                    variant="primary"
                                                    type="button"
                                                    className="sub_but"
                                                    onClick={submitCode}
                                                >
                                                    Submit
                                                </Button>
                                            </Form.Group>
                                        </Col>
                                    </Row>


                                </Form>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col>
                                <DataTable
                                    title="CareFi Code Redeem List"
                                    columns={columns}
                                    data={allCals}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={total}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={[10, 20, 50]}
                                    onChangePage={(newPage) => {

                                        fetchCals(newPage, limit);

                                    }}
                                    onChangeRowsPerPage={(newLimit) => {
                                        setLimit(newLimit);
                                        fetchCals(1, newLimit);
                                    }}
                                />
                            </Col>
                        </Row>

                    </div>
                </div>
            </div>
        </LoadingOverlay>
    );
};

export default UserEscapeBucks;
